import getHexColorFromNamed from './getHexColorFromNamed'
export * from './colors'
export { getHexColorFromNamed }
